<template>
  <div>
    <Dialog
      :visible.sync="visible"
      :header="form.pastamp ? 'Editar PAT ' + form.id : 'Adicionar PAT'"
      modal
      :style="{ width: $isMobile() ? '100vw' : '60vw' }"
    >
      <form @submit.prevent="submit" ref="form">
        <div class="p-fluid p-grid" style="min-height: 40vh">
          <!-- CLIENTS -->
          <div class="p-field p-col-12 p-md-10 p-mt-4">
            <AppAutocomplete
              label="Cliente"
              fieldId="inputClientId"
              :optionLabel="getClientLabel"
              :editModel="getCurrentClient"
              :fetchFunction="fetchClients"
              optionValue="compositeKey"
              v-model="form.clientCompositeKey"
              v-validate.disable="'required'"
              data-vv-name="inputClientId"
              placeholder="Selecionar cliente"
              @selection-change="clientChange"
              @clear-selection="reset"
              appendTo="body">
              <template #option="slotProps">
                <div>
                  <b>{{ slotProps.option.name }}</b>
                  <br />
                  <span style="white-space: normal;word-break: break-word;">
                    <span v-if="slotProps.option.email">EMAIL: {{ slotProps.option.email }} | </span>
                    <span v-if="slotProps.option.fiscalNumber">NIF: {{ slotProps.option.fiscalNumber }} | </span>
                    <span v-if="slotProps.option.telephone">TEL.: {{ slotProps.option.telephone }} | </span>
                    <span v-if="slotProps.option.mobilPhone">TELM.: {{ slotProps.option.mobilPhone }}</span>
                  </span>
                </div>
              </template>
            </AppAutocomplete>
              <span v-if="errors.has('inputClientId')" class="p-error">
                Cliente é Obrigatório
              </span>
          </div>
          <div class="p-field p-col-12 p-md-2 p-mt-4">
            <template v-if="form.clientId && form.client">
              <Button
                v-if="tabActiveClient == 0"
                icon="pi pi-eye-slash"
                class="p-button-info p-mr-2"
                @click="tabActiveClient = null"
              />
              <Button
                v-else
                icon="pi pi-eye"
                class="p-button-info p-mr-2"
                @click="tabActiveClient = 0"
              />
            </template>
            <Button
              icon="pi pi-pencil"
              class="p-button-primary p-mr-2"
              @click="editClient"
              v-if="form.clientId"
            />
            <Button
              icon="pi pi-plus"
              class="p-button-success"
              @click="createNewClient"
            />
          </div>

          <div class="p-fluid p-grid p-col-12" v-if="form.clientId && form.client">
            <Accordion class="p-accordion-app p-col-12 p-md-12" :activeIndex="tabActiveClient">
                <AccordionTab :header="`Detalhes do Cliente ${form.client.name}`">
                  <div class="p-col-12 p-grid">
                    <div class="p-field p-col-12 p-md-4">
                      <label>Morada</label
                      ><InputText v-model="form.client.address" disabled />
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                      <label>Localidade</label>
                      <InputText v-model="form.client.city" disabled />
                    </div>
                    <div class="p-field p-col-12 p-md-4">
                      <label>Código Postal</label
                      ><InputText v-model="form.client.zipCode" disabled />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <label>Email</label>
                      <InputText v-model="form.client.email" disabled />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <label>Telefone</label
                      ><InputText v-model="form.client.telephone" disabled />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <label>Telemóvel</label>
                      <InputText v-model="form.client.mobilPhone" disabled />
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                      <label>NIF</label>
                      <InputText v-model="form.client.fiscalNumber" disabled />
                    </div>
                  </div>
                </AccordionTab>
            </Accordion>

            <div class="p-field p-col-12 p-md-10 p-mt-4">
              <AppAutocomplete
                label="Entidade"
                fieldId="inputEntityId"
                optionLabel="name"
                optionValue="id"
                v-model="form.entityId"
                :editModel="getCurrentEntity"
                :fetchFunction="fetchEntities"
                placeholder="Selecionar Entidade"
                @selection-change="entityChange"
                appendTo="body"></AppAutocomplete>
            </div>
            <div class="p-field p-col-12 p-md-2 p-mt-4">
              <template v-if="form.entityId && form.entity">
                <Button
                  v-if="tabActiveEntity == 0"
                  icon="pi pi-eye-slash"
                  class="p-button-info p-mr-2"
                  @click="tabActiveEntity = null"
                />

                <Button
                  v-else
                  icon="pi pi-eye"
                  class="p-button-info p-mr-2"
                  @click="tabActiveEntity = 0"
                />
              </template>
              <Button
                v-if="form.entityId"
                icon="pi pi-pencil"
                class="p-button-primary p-mr-2"
                @click="editEntity"
              />
              <Button
                icon="pi pi-plus"
                class="p-button-success"
                @click="createNewEntity"
              />
            </div>
          </div>

          <div class="p-fluid p-grid p-col-12" v-if="form.entityId && form.entity">
            <Accordion class="p-accordion-app p-col-12 p-md-12" :activeIndex="tabActiveEntity">
              <AccordionTab :header="`Detalhes do Cliente ${form.entity.name}`">
                <div class="p-col-12 p-grid">
                  <div class="p-field p-col-12 p-md-4">
                    <label>Morada</label>
                    <InputText v-model="form.entity.address" disabled />
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label>Código Postal</label>
                    <InputText v-model="form.entity.zip_code" disabled />
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label>Email</label>
                    <InputText v-model="form.entity.email" disabled />
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label>Telefone</label>
                    <InputText v-model="form.entity.telephone" disabled />
                  </div>
                  <div class="p-field p-col-12 p-md-4">
                    <label>NIF</label>
                    <InputText v-model="form.entity.nif" disabled />
                  </div>
                </div>
              </AccordionTab>
            </Accordion>
          </div>

          <div v-if="form.clientId" class="p-fluid p-grid p-col-12">
            <div class="p-field p-col-12 p-md-12">
              <label>Equipamento</label>
              <div class="p-inputgroup">
                <Dropdown
                  :options="equipments"
                  v-model="form.equipmentId"
                  :optionLabel="getEquipmentsLabel"
                  optionValue="id"
                  name="equipmentId"
                  v-validate="'required'"
                  :class="{ 'p-invalid': errors.has('equipmentId') }"
                  filter
                  appendTo="body"
                  placeholder="Selecionar equipamento"
                  @change="equipamentChange"
                  style="flex: 1"
                />
                <template v-if="form.equipmentId && form.equipment">
                  <Button
                    v-if="tabActiveEquipment == 0"
                    icon="pi pi-eye-slash"
                    class="p-button-info"
                    @click="tabActiveEquipment = null"
                  />

                  <Button
                    v-else
                    icon="pi pi-eye"
                    class="p-button-info"
                    @click="tabActiveEquipment = 0"
                  />
                </template>

                <Button
                  v-if="form.equipmentId"
                  icon="pi pi-pencil"
                  class="p-button-primary"
                  @click="editEquipment"
                />
                <Button
                  icon="pi pi-plus"
                  class="p-button-success"
                  @click="createNewEquipment"
                />
              </div>
              <span v-if="errors.has('equipmentId')" class="p-error">
                Equipamento é Obrigatório
              </span>
            </div>
          </div>
          <div class="p-fluid p-grid p-col-12" v-if="form.equipment">

            <Accordion class="p-accordion-app p-col-12 p-md-12" :activeIndex="tabActiveEquipment">
              <AccordionTab :header="`Detalhes do Equipamento MARCA: ${form.equipment.brand ?? ''} | MODELO: ${form.equipment.model} | SÉRIE: ${form.equipment.serie}`">
                <div class="p-col-12 p-grid">
                  <div class="p-field p-col-12 p-md-4">
                  <label>Marca</label>
                  <InputText v-model="form.equipment.brand" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                  <label>Modelo</label>
                  <InputText v-model="form.equipment.model" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                  <label>Série</label>
                  <InputText v-model="form.equipment.serie" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                  <label>Data de Compra</label>
                  <InputText v-model="form.equipment.purchaseDate" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                  <label>Estado</label>
                  <InputText v-model="form.equipment.situation" disabled />
                </div>
                <div class="p-field p-col-12 p-md-4">
                  <label>Comentários</label>
                  <InputText v-model="form.equipment.comments" disabled />
                </div>
                </div>
              </AccordionTab>
            </Accordion>

            <div class="p-col-12"><h3>Informação do PAT</h3></div>
            <div class="p-fluid p-grid p-col-12">
              <div class="p-field p-col-12 p-md-2 p-d-flex p-flex-column">
                <label for="closed" style="margin: 0">Fechado</label>
                <InputSwitch id="closed" v-model="form.closed" class="p-mt-2" />
              </div>
              <div class="p-field p-col-12 p-md-3">
                <label for="patStatus">Estado</label>
                <Dropdown
                  id="patStatus"
                  :options="patStatus"
                  v-model="form.status"
                  optionLabel="field"
                  optionValue="field"
                  name="patStatus"
                  v-validate="'required'"
                  :class="{ 'p-invalid': errors.has('patStatus') }"
                  placeholder="Selecionar Estado"
                  filter
                  appendTo="body"
                  @change="checkInternalStates"
                />
                <span v-if="errors.has('patStatus')" class="p-error">
                  Estado do PAT é Obrigatório
                </span>
              </div>
              <div v-if="can('seeInternalStatesPats')" class="p-field p-col-12 p-md-3" v-show="listInternalStates.length">
                <label for="internalState">Estado Interno</label>
                <Dropdown
                  id="internalState"
                  :options="listInternalStates"
                  v-model="form.internalState"
                  optionLabel="name"
                  optionValue="id"
                  name="internalState"
                  placeholder="Selecionar Estado Interno"
                  filter
                  appendTo="body"
                />
              </div>
            </div>
            <div class="p-field p-col-12 p-md-2">
              <label for="ptipo">Tipo</label>
              <Dropdown
                id="patTypes"
                :options="patTypes"
                v-model="form.type"
                optionLabel="name"
                optionValue="name"
                name="patTypes"
                v-validate="'required'"
                :class="{ 'p-invalid': errors.has('patTypes') }"
                placeholder="Selecionar tipo"
                filter
                appendTo="body"
              />
              <span v-if="errors.has('patTypes')" class="p-error">
                Tipo do PAT é Obrigatório
              </span>
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label for="siuation">Situação</label>
              <Dropdown
                id="siuation"
                :options="situations"
                v-model="form.situation"
                name="siuation"
                optionLabel="name"
                optionValue="name"
                v-validate="'required'"
                :class="{ 'p-invalid': errors.has('siuation') }"
                placeholder="Selecionar situação"
                appendTo="body"
                filter
              />
              <span v-if="errors.has('siuation')" class="p-error">
                Situação é Obrigatória
              </span>
            </div>
            <div class="p-field p-col-12 p-md-3">
              <label for="tecnm">Técnico</label>
              <Dropdown
                id="technicalId"
                :options="technicians"
                v-model="form.technicalId"
                optionLabel="username"
                optionValue="tecnico"
                name="technicalId"
                :class="{ 'p-invalid': errors.has('technicalId') }"
                placeholder="Selecionar técnico"
                filter
                appendTo="body"
              />
              <span v-if="errors.has('technicalId')" class="p-error">
                Tecnico é Obrigatório
              </span>
            </div>
            <div class="p-field p-col-12 p-md-3">
              <label for="dpt">Departamento</label>
              <Dropdown
                id="department"
                :options="departments"
                v-model="form.department"
                optionLabel="name"
                optionValue="name"
                name="department"
                v-validate="'required'"
                :class="{ 'p-invalid': errors.has('department') }"
                placeholder="Selecionar departamento"
                appendTo="body"
                filter
              />
              <span v-if="errors.has('department')" class="p-error">
                Departamento é Obrigatório
              </span>
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label>Problema</label>
              <Textarea
                v-model="form.problem"
                name="problem"
                v-validate="'required'"
                :class="{ 'p-invalid': errors.has('problem') }"
                autoResize
                rows="5"
              />
              <span v-if="errors.has('problem')" class="p-error">
                Problema é Obrigatório
              </span>
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label>Resumo</label>
              <Textarea
                v-model="form.resume"
                name="resume"
                v-validate="'max:500'"
                :class="{ 'p-invalid': errors.has('resume') }"
                autoResize
                rows="5"
              />
              <span v-if="errors.has('resume')" class="p-error">
                Resumo é Obrigatório
              </span>
            </div>
            <div class="p-field p-col-12 p-md-4">
              <label>Solução</label>
              <Textarea
                v-model="form.solution"
                name="solution"
                :class="{ 'p-invalid': errors.has('solution') }"
                autoResize
                rows="5"
              />
              <span v-if="errors.has('solution')" class="p-error">
                Solução é Obrigatória
              </span>
            </div>
            <div class="p-fluid p-grid p-col-12">
              <div class="p-field p-col-12 p-md-4">
                <label>Status Público</label>
                <Dropdown
                  id="status_public"
                  :options="listPublicStatus"
                  v-model="form.publicStatus"
                  optionLabel="name"
                  optionValue="name"
                  name="publicStatus"
                  :class="{ 'p-invalid': errors.has('publicStatus') }"
                  placeholder="Selecionar Status Público"
                  appendTo="body"
                  filter
                />
              </div>
              <div class="p-field p-col-12 p-md-4">
                <label>Localização (nref)</label>
                <InputText v-model="form.nRef" />
              </div>
            </div>
          </div>
        </div>
      </form>

      <template #footer>
        <Button
          label="Cancelar"
          icon="pi pi-times"
          class="p-button-danger"
          @click="cancel"
        />
        <Button
          label="Guardar"
          class="p-button-success"
          icon="pi pi-save"
          @click.prevent="submit"
        />
      </template>
    </Dialog>
    <ClientModal
      :visible.sync="clientForm.show"
      :data="clientForm.data"
      @cancel="closeClientForm"
      @created="createdClient"
      @updated="updatedClient"
    />
    <EquipmentModal
      :visible.sync="equipmentForm.show"
      :data="equipmentForm.data"
      @cancel="closeEquipmentForm"
      @created="createdEquipment"
      @updated="updatedEquipment"
    />
    <EntityForm
      :visible.sync="entityForm.show"
      :data="entityForm.data"
      @cancel="closeEntityForm"
      @created="createdEntity"
      @updated="updatedEntity"
    />
  </div>
</template>

<script>
import internalStatus from "@/services/internal-state.service";
import PatService from "@/services/pat.service";
import ClientService from "@/services/client.service";
import EntitiesService from "@/services/entities.service";
import EquipmentService from "@/services/equipment.service";
import ClientModal from "@/components/clients/ClientModal.vue";
import EquipmentModal from "@/components/equipaments/EquipmentModal.vue";
import EntityForm from "@/components/entity/EntityForm.vue";
import AppAutocomplete from '@/components/elements/AppAutocomplete.vue'

export default {
  name: "PatModal",
  props: {
    visible: Boolean,
    data: Object,
  },
  components: { ClientModal, EquipmentModal, EntityForm, AppAutocomplete },
  emits: ["cancel", "created", "updated"],
  watch: {
    async visible() {
      this.reset();
      if (this.visible === true) {
        this.$validator.reset();
        this.$validator.resume();
        this.form = { ...this.data };
        if (this.form.id) {
          if (this.form.clientId) {
            this.form.clientCompositeKey = `${this.form.clientId}-${this.form.client.estab}`;
          }
          await this.clientChange(this.form.clientCompositeKey);
          await this.checkInternalStates();
        }
      }
    },
  },
  async created() {
    this.loading = true;
    this.patTypes = await PatService.getTipos();
    this.technicians = await PatService.getTechnicians();
    this.departments = await PatService.getDepartments();
    this.patStatus = await PatService.getAllStatus();
    this.listPublicStatus = await PatService.getPublicStatus();
    this.situations = await EquipmentService.status();
    return (this.loading = true);
  },
  data() {
    return {
      loading: false,
      form: {
        client: null,
        entity: null,
        equipment: null,
        internalState: null,
      },
      clients: [],
      equipments: [],
      patTypes: [],
      technicians: [],
      departments: [],
      listPublicStatus: [],
      patStatus: [],
      listInternalStates: [],
      situations: [],
      entities: [],
      clientForm: { show: false, data: {} },
      equipmentForm: { show: false, data: {} },
      entityForm: { show: false, data: {} },
      tabActiveClient: null,
      tabActiveEntity: null,
      tabActiveEquipment: null
    };
  },
  methods: {
    async checkInternalStates() {
      if (!this.can('seeInternalStatesPats')) {
        return;
      }

      if (!this.form.status) {
        this.listInternalStates = [];
        this.form.internalState = null;
        return;
      }

      let id = this.patStatus.find(e => e.field == this.form.status)?.id;
      if (!id) return;

      try {
        let response = await internalStatus.getByParentStatus(id);
        this.listInternalStates = response;
        if (
          !this.listInternalStates.find(
            (status) => status.id === this.form.internalState
          )
        ) {
          this.form.internalState = response.length ? response[0].id : null;
        }
      } catch (error) {
        console.error('Error fetching Internal States:', error);
      }
    },
    async fetchClients(search = '') {
      try {
        let clients = await ClientService.query({ 'search': search });

        return clients.map(c => ({
          ...c,
          compositeKey: `${c.id}-${c.estab}`
        }));
      } catch (error) {
        console.error('Error fetching Clients:', error);
        throw error;
      }
    },
    async getCurrentClient(compositeValue) {
      try {
        const id = compositeValue?.includes('-') ? compositeValue.split('-')[0] : compositeValue;
        const estab = compositeValue?.includes('-') ? compositeValue.split('-')[1] : 0;

        let response = await ClientService.query({ 'no': id, 'estab': estab });
        if (!response.length) return null;

        return { ...response[0], compositeKey: `${response[0].id}-${response[0].estab}` };
      } catch (error) {
        console.error('Error fetching Clients:', error);
        throw error;
      }
    },
    async fetchEntities(search = '') {
      try {
        let entities = await EntitiesService.query({ 'search': search });

        return entities;
      } catch (error) {
        console.error('Error fetching Entities:', error);
        throw error;
      }
    },
    async getCurrentEntity(row) {
      try {
        let response = await EntitiesService.query({ 'no': row });

        if (!response.length) {
          return null;
        }

        return response[0];
      } catch (error) {
        console.error('Error fetching Entities:', error);
        throw error;
      }
    },
    reset() {
      this.form = {
        id: null,
        clientId: null,
        equipmentId: null,
        compositeKey: null,
        estab: null,
        entityId: null,
        closed: false,
        entity: null,
        client: null,
        equipment: null,
      };
      this.$validator.pause();
      this.$validator.reset();
    },
    cancel() {
      this.$validator.pause();
      this.$validator.reset();
      this.reset();
      return this.$emit("cancel");
    },
    getClientLabel(client) {
      if (!client) return '';
      return `${client.name} | EMAIL: ${client.email} | NIF: ${client.fiscalNumber} | TEL.: ${client.telephone} | TELM.: ${client.mobilPhone}`;
    },
    getEquipmentsLabel(equipment) {
      return `MARCA: ${equipment.brand ?? ""} | MODELO: ${
        equipment.model
      } | SÉRIE: ${equipment.serie}`;
    },
    async clientChange(compositeValue) {
      if (!compositeValue) return;

      const [id, estab] = compositeValue.split('-');

      this.form.clientId = id;
      this.form.estab = estab;

      this.form.client = await this.getCurrentClient(compositeValue);
      this.equipments = await ClientService.getEquipments(id, estab);
    },
    findEquipmentById(id) {
      return this.equipments.find((equipment) => equipment.id === id);
    },
    equipamentChange() {
      return (this.form.equipment = this.findEquipmentById(
        this.form.equipmentId
      ));
    },
    async entityChange(row) {
      let entityId = row ?? this.form.entityId;
      const selectedEntity = await this.getCurrentEntity(entityId)
      if (!selectedEntity) {
        this.form.entityId = null;
      }

      this.form.entity = selectedEntity
      this.$forceUpdate()
    },
    async submit() {
      const isValid = await this.$validator.validateAll();
      if (!isValid) {
        return;
      }
      let playload = {
        ...this.form,
      };
      if (this.form.closed !== undefined && this.form.closed === true) {
        playload.closed = 1;
      } else {
        playload.closed = 0;
      }
      this.$validator.pause();
      this.$validator.reset();
      if (this.form.id) {
        await PatService.update(this.form.id, playload).then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: `Erro ao Atualizar o PAT`,
              detail: "",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `PAT Atualizado`,
            detail: "",
            life: 3000,
          });
          return this.$emit("updated", response);
        });
      } else {
        await PatService.create(playload).then((response) => {
          if (!response) {
            return this.$toast.add({
              severity: "error",
              summary: `Erro ao Criar PAT`,
              detail: "",
              life: 3000,
            });
          }
          this.$toast.add({
            severity: "success",
            summary: `PAT Criado`,
            detail: "",
            life: 3000,
          });
          return this.$emit("created", response);
        });
      }
    },
    closeClientForm() {
      return (this.clientForm = { show: false, data: {} });
    },
    createNewClient() {
      return (this.clientForm = { show: true, data: {} });
    },
    editClient() {
      return (this.clientForm = {
        show: true,
        data: { ...this.form.client },
      });
    },
    createdClient(client) {
      this.clients.push(client);
      this.form.clientId = client.id;
      this.form.client = client;
      return this.closeClientForm();
    },
    updatedClient(client) {
      this.form.client = client;
      return this.closeClientForm();
    },
    closeEntityForm() {
      return (this.entityForm = { show: false, data: {} });
    },
    createNewEntity() {
      return (this.entityForm = { show: true, data: {} });
    },
    editEntity() {
      return (this.entityForm = {
        show: true,
        data: { ...this.form.entity },
      });
    },
    createdEntity(entity) {
      this.entities.push(entity);
      this.form.entityId = entity.id;
      this.form.entity = entity;
      return this.closeEntityForm();
    },
    updatedEntity(entity) {
      this.form.entity = entity;
      return this.closeEntityForm();
    },
    closeEquipmentForm() {
      return (this.equipmentForm = { show: false, data: {} });
    },
    createNewEquipment() {
      return (this.equipmentForm = {
        show: true,
        data: { clientId: this.form.clientId },
      });
    },
    editEquipment() {
      return (this.equipmentForm = {
        show: true,
        data: {
          ...this.form.equipment,
          serialNumber: this.form.equipment.serie,
          status: this.form.equipment.situation,
          observation: this.form.equipment.comments,
          clientId: this.form.clientId
        },
      });
    },
    createdEquipment(equipment) {
      this.equipments.push(equipment);
      this.form.equipmentId = equipment.id;
      this.form.equipment = equipment;
      return this.closeEquipmentForm();
    },
    updatedEquipment(client) {
      this.form.client = client;
      return this.closeEquipmentForm();
    },
  },
};
</script>

<style>

.p-accordion-app.p-accordion .p-accordion-header .p-accordion-header-link
{
  padding: 0.8rem 1.25rem;
  border: 1px solid #dee2e6;
  color: #212529;
  background: #f2f2f2f2;
  font-weight: 600;
  border-radius: 4px;
  transition: box-shadow 0.15s;
}

</style>